import {
  ConfirmDialog,
  Loading,
  SimpleDialog,
  TwoStepSteps,
  Typography,
  type TwoStepMethodKind,
} from '@idu-nightlife/ui-kit';
import type { AccountSecurityDialog, AccountSecurityViewProps } from './account-security.types';

const METHOD_NAMES: Record<TwoStepMethodKind, string> = {
  authenticator: 'your authenticator app',
  sms: 'text message codes',
};

const confirmCopy = (dialog: AccountSecurityDialog) => {
  if (dialog.name === 'remove') {
    return {
      title: 'Remove This Way to Sign In',
      body: `You won't be able to sign in with ${METHOD_NAMES[dialog.kind]} any more, and remembered devices will be asked again.`,
      submitLabel: 'Remove',
    };
  }
  if (dialog.name === 'turn-off') {
    return {
      title: 'Turn Off Two-Step Sign-In',
      body: 'Signing in will only need your password or Google account. Your ways to sign in are kept.',
      submitLabel: 'Turn Off',
    };
  }
  return {
    title: 'Forget All Devices',
    body: 'Every device you chose not to be asked on will ask for a code the next time you sign in.',
    submitLabel: 'Forget All',
  };
};

type AccountSecurityDialogsProps = Pick<
  AccountSecurityViewProps,
  'dialog' | 'busy' | 'twoStepSteps' | 'onConfirm' | 'onCloseDialog'
>;

export const AccountSecurityDialogs = ({
  dialog,
  busy,
  twoStepSteps,
  onConfirm,
  onCloseDialog,
}: AccountSecurityDialogsProps) => {
  if (!dialog) return null;

  if (dialog.name === 'add-method' || dialog.name === 'verify') {
    return (
      <SimpleDialog open onClose={busy ? undefined : onCloseDialog} maxWidth="sm">
        <SimpleDialog.Content sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {dialog.name === 'verify' && (
            <Typography.Body>Confirm it&apos;s you to continue with this change.</Typography.Body>
          )}
          {twoStepSteps ? <TwoStepSteps {...twoStepSteps} /> : <Loading />}
        </SimpleDialog.Content>
      </SimpleDialog>
    );
  }

  const copy = confirmCopy(dialog);
  return (
    <ConfirmDialog
      open
      title={copy.title}
      submitLabel={copy.submitLabel}
      submitColor="error"
      disableDefaultEndIcon
      submitDisabled={busy}
      cancelDisabled={busy}
      onSubmit={onConfirm}
      onCancel={onCloseDialog}
    >
      <Typography.Body>{copy.body}</Typography.Body>
    </ConfirmDialog>
  );
};
